import { Box, Divider, Stack, Typography } from '@mui/material';

import { CustomButton } from '@/shared/components/custom-button';
import CustomModal from '@/shared/components/custom-modal';

import { fmtAmount, fmtUsd } from './formatters';
import { CoinModalProps } from './types';

export const CollateralizeModal = ({ open, onClose, coin }: CoinModalProps) => (
  <CustomModal
    open={open}
    onClose={onClose}
    title={`Collateralize ${coin.symbol}`}
    withCloseButton
    sx={{ width: 440 }}
  >
    <Stack mt="16px" gap="24px" flexDirection="column">
      <Divider sx={{ borderColor: '#2E3348' }} />
      <Box bgcolor="#1E2333" border="1px solid #2E3348" borderRadius="10px" p="16px">
        <Stack gap="12px">
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body3" color="text.secondary">
              Asset
            </Typography>
            <Typography variant="body3">{coin.symbol}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body3" color="text.secondary">
              Balance
            </Typography>
            <Typography variant="body3">
              {fmtAmount(coin.balance)} {coin.symbol}
            </Typography>
          </Stack>
          {coin.usdValue != null && (
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body3" color="text.secondary">
                Present Value
              </Typography>
              <Typography variant="body3">{fmtUsd(coin.usdValue)}</Typography>
            </Stack>
          )}
          <Divider sx={{ borderColor: '#2E3348' }} />
          <Typography variant="body3" color="text.secondary">
            Use {coin.symbol} as collateral to access liquidity without selling your position.
          </Typography>
        </Stack>
      </Box>
      <Stack gap="12px">
        <CustomButton
          sx={{ background: '#39CA88', height: 44, borderRadius: '10px' }}
          onClick={onClose}
        >
          Collateralize {coin.symbol}
        </CustomButton>
        <CustomButton
          onClick={onClose}
          sx={{ background: '#2A3040', borderRadius: '8px', height: 44 }}
        >
          Cancel
        </CustomButton>
      </Stack>
    </Stack>
  </CustomModal>
);
